import React from "react";
import { Separator } from "./ui/separator";
import { Car, Phone, Mail, Send, MessageCircle, Clock } from "lucide-react";
import { useI18n } from "../i18n";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { CurrencySwitcher } from "./CurrencySwitcher";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer id="contacts" className="dark-panel" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-accent text-accent-foreground">
                <Car className="h-5 w-5" />
              </span>
              <span className="font-display text-lg font-semibold">Transfer24</span>
            </div>
            <p className="mt-4 text-sm text-white/70 leading-relaxed max-w-xs">{t("footer.tagline")}</p>
            <div className="mt-4 inline-flex items-center gap-2 text-sm text-accent">
              <Clock className="h-4 w-4" /> {t("footer.available")}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-white/60">{t("footer.contacts")}</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a href="tel:+420728992513" className="flex items-center gap-2 text-white/80 hover:text-accent transition-colors" data-testid="footer-phone-link">
                  <Phone className="h-4 w-4" /> +420 728 992 513
                </a>
              </li>
              <li>
                <a href="mailto:order@transfer24.cz" className="flex items-center gap-2 text-white/80 hover:text-accent transition-colors" data-testid="footer-email-link">
                  <Mail className="h-4 w-4" /> order@transfer24.cz
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-white/60">{t("footer.follow")}</h4>
            <div className="mt-4 flex items-center gap-3">
              <a href="https://t.me/" target="_blank" rel="noreferrer" className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 hover:bg-accent hover:text-accent-foreground transition-colors" data-testid="footer-telegram-link" aria-label="Telegram">
                <Send className="h-5 w-5" />
              </a>
              <a href="https://wa.me/420728992513" target="_blank" rel="noreferrer" className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 hover:bg-accent hover:text-accent-foreground transition-colors" data-testid="footer-whatsapp-link" aria-label="WhatsApp">
                <MessageCircle className="h-5 w-5" />
              </a>
            </div>
            <div className="mt-6 flex items-center gap-2.5">
              <LanguageSwitcher />
              <CurrencySwitcher />
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-white/10" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Transfer24. {t("footer.rights")}</span>
          <span>Geodata © OpenStreetMap · Routing via OSRM</span>
        </div>
      </div>
    </footer>
  );
};
